import { Navigate } from "react-router-dom";
import { AuthElement } from "../components/auth-element/auth-element";

export const CallbackPage = () => {
  return (
    <AuthElement>
      <Navigate to="/" replace />
    </AuthElement>
  );
};
